import { BadgeCheck } from "lucide-react";
import { isRenovationProgramService } from "@/lib/serviceCatalog";

interface RenovationProgramBadgeProps {
  service: string;
  compact?: boolean;
}

const RenovationProgramBadge = ({ service, compact = false }: RenovationProgramBadgeProps) => {
  if (!isRenovationProgramService(service)) return null;

  return (
    <span
      className="inline-flex max-w-full items-center gap-1.5 rounded-full border border-sky-200 bg-white px-2.5 py-1 text-[11px] font-bold leading-4 text-sky-800 shadow-sm"
      aria-label="Προέλευση: Πρόγραμμα Ανακαινίζω"
    >
      <BadgeCheck className="h-3.5 w-3.5 shrink-0 text-red-600" aria-hidden="true" />
      <span className={compact ? "truncate" : "whitespace-normal"}>Πρόγραμμα Ανακαινίζω</span>
    </span>
  );
};

export default RenovationProgramBadge;
